/*
|==========================================================================
| WordPress + Foundation
|==========================================================================
| 
| These functions make sure WordPress and Foundation play nice together,
| and this is also where we declare functions defined in this folder.
|
|==========================================================================
|
*/

document.addEventListener( "DOMContentLoaded", function() {

  // Evolving function for WCAG guidelines
  // v8_wcag();

  // Detect browser and device
  detectBrowserAndDevice();

  // Enable skrollr
  // var s = skrollr.init();

  // Gravity Forms Placeholder Clearing
  // gravity_forms_placeholders();

  // Inline SVG replacement
  // inline_svg_replacement();

  // Isotope Masonry
  // isotope_masonry();

  // TablePress Cleanup
  // tablepress();

  // Event Target Testing
  jQuery(document).click(function(event) {

  });

  // Window scroll detection
  jQuery(window).bind("scroll", function(event) {        

  });

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

	 // Makes sure last grid item floats left
  jQuery('.archive-grid .columns').last().addClass( 'end' );

	// Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen flex-video'/>");
    } else {
      jQuery(this).wrap("<div class='flex-video mb4'/>");
    }
  });

  // jQuery('.lightgallery').magnificPopup({
  //   delegate: 'a', // child items selector, by clicking on it popup will open
  //   type: 'image',
  //   gallery: {
  //     enabled: true
  //   },
  //   zoom: {
  //     enabled: true,
  //     duration: 300, // don't foget to change the duration also in CSS
  //     opener: function(element) {
  //       return element.find('img');
  //     }
  //   },
  //   image: {
  //     // options for image content type
  //     titleSrc: 'title'
  //   }
  //   // other options
  // });

  const $dropdownMenu = jQuery('#mega-menu-dropdown');

  if( $dropdownMenu.length > 0) {
    $dropdownMenu.find(".is-dropdown-submenu").each(function () {
      if (jQuery(this).closest(".mega-dropdown").length) {
          jQuery(this).removeClass("is-dropdown-submenu");
          jQuery(this).find("li").removeClass("is-dropdown-submenu-item");
      }
    });
  }

  // Wait 500ms and add the .animated class to .hero-content if body has .page-template-template-homepage
  setTimeout(function() {
    if (document.body.classList.contains('page-template-template-homepage')) {
      const heroContent = document.querySelector('.hero-content');
      if (heroContent) {
        heroContent.classList.add('animated');
      }
    }
  }, 500);

  setTimeout(function() {
    if (document.body.classList.contains('page-template-template-homepage')) {
      const illustrationContent = document.querySelector('.col-illustration');
      if (illustrationContent) {
        illustrationContent.classList.add('animated');
      }
    }
  }, 700);

  toggleSlick();

  jQuery(window).on("resize", toggleSlick);
  jQuery(window).on("resize", resizeIframe);

  jQuery(".slideshow-section").each((function(){var t=jQuery(this),e=t.find(".slideshow, .articles-slider"),i=t.find(".slideshow-arrows"),o={primary:{slidesToScroll:1,slidesToShow:1,rows:0,prevArrow:'<button class="slick-prev"><i class="icon icon-arrow-left"></i><span class="visually-hidden">Previous</span></button>',nextArrow:'<button class="slick-next"><i class="icon icon-arrow-right"></i><span class="visually-hidden">Next</span></button>',appendArrows:i},secondary:{slidesToScroll:1,slidesToShow:1,rows:0,fade:!0,adaptiveHeight:!0,prevArrow:'<button class="slick-prev"><i class="icon icon-arrow-left"></i><span class="visually-hidden">Previous</span></button>',nextArrow:'<button class="slick-next"><i class="icon icon-arrow-right"></i><span class="visually-hidden">Next</span></button>',appendArrows:i}};e.hasClass("slideshow")?e.slick(o.primary):e.hasClass("articles-slider")&&e.slick(o.secondary)})),jQuery(".images-slideshow").slick({slidesToScroll:1,rows:0,slidesToShow:5,prevArrow:'<button class="slick-prev"><i class="icon icon-arrow-left"></i><span class="visually-hidden">Previous</span></button>',nextArrow:'<button class="slick-next"><i class="icon icon-arrow-right"></i><span class="visually-hidden">Next</span></button>',responsive:[{breakpoint:1200,settings:{slidesToScroll:1,slidesToShow:4}},{breakpoint:1024,settings:{slidesToScroll:1,slidesToShow:3}},{breakpoint:768,settings:{slidesToScroll:1,slidesToShow:2}},{breakpoint:480,settings:{slidesToScroll:1,slidesToShow:1}}]})

  jQuery(".filter-section").ajaxFiltering({ 
    container:".post-cards",
    items:".col",
    filterForm:".filter-form > form",
    filterLists:"[data-category]",
    filterLinks:"[data-filter]",
    activeClass:"active",
    loadClass:"loading",
    btnMore:".btn-more",
    paging:".nav-links",
    usePaging:!0,
    infiniteScroll:!1,
    ajaxPrefix:"ajax=2"
  });

  if( 
    jQuery(".page-template-template-blog").length > 0 ||
    jQuery(".page-template-template-ebooks").length > 0 ) {
    searchBlog();
  };
});

/*
|==========================================================================
| Use this function to fire events after the entire window has loaded,
| including images and CSS files.
|==========================================================================
*/

window.onload = function() {

    jQuery('.dropdown.menu.hidden').removeClass('hidden');

  AOS.init({

    // Global settings:
    disable: 'mobile', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    // startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
    // initClassName: 'aos-init', // class applied after initialization
    // animatedClassName: 'aos-animate', // class applied on animation
    // useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    // disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    // debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    // throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
    
  
    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    // offset: 120, // offset (in px) from the original trigger point
    // delay: 0, // values from 0 to 3000, with step 50ms
    // duration: 400, // values from 0 to 3000, with step 50ms
    // easing: 'ease', // default easing for AOS animations
    // once: false, // whether animation should happen only once - while scrolling down
    // mirror: false, // whether elements should animate out while scrolling past them
    // anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation);
  });

// Get button's data-language-selected value

const languageButton = document.getElementById("languageButton-header");
const languageButtonMobile = document.getElementById("languageButton-mobile");
const languageButtonFooter = document.getElementById("languageButton-header");

if (languageButton) {
  const selectedLanguage = languageButton.dataset.languageSelected;

  // Find the corresponding radio button by ID
  const radioToCheckHeader = document.getElementById(`language-header-${selectedLanguage}`);
  const radioToCheckMobile = document.getElementById(`language-mobile-${selectedLanguage}`);
  const radioToCheckFooter = document.getElementById(`language-footer-${selectedLanguage}`);
  // If the radio button exists, mark it as checked
  if (radioToCheckHeader) {
    radioToCheckHeader.checked = true;
  }
  if (radioToCheckMobile) {
    radioToCheckMobile.checked = true;
  }
  if (radioToCheckFooter) {
    radioToCheckFooter.checked = true;
  }
} 

const iframe = document.querySelector("#contact iframe");
if (iframe) {
    iframe.addEventListener("load", resizeIframe);
}

};


function toggleSlick() {
  if (window.innerWidth < 1024) {
    if (jQuery(".assessment-list").hasClass("slick-initialized")) {
      jQuery(".assessment-list").slick("unslick");
    }
  } else {
    if (!jQuery(".assessment-list").hasClass("slick-initialized")) {
      jQuery(".assessment-list").slick({
        slidesToScroll: 1,
        rows: 0,
        slidesToShow: 5,
        prevArrow:
          '<button class="slick-prev"><i class="icon icon-arrow-left"></i><span class="visually-hidden">Previous</span></button>',
        nextArrow:
          '<button class="slick-next"><i class="icon icon-arrow-right"></i><span class="visually-hidden">Next</span></button>',
      });
    }
  }
}

function resizeIframe() {
  const iframe = document.querySelector("#contact iframe");
  if (iframe && iframe.contentWindow) {
      iframe.style.height = iframe.contentWindow.document.body.scrollHeight + "px";
  }
}

(function($) {
  function AjaxFiltering(options) {
      this.options = $.extend({
          container: ".js-ajax-container",
          items: ".filter-item",
          filterForm: ".filter-form",
          searchForm: ".search-form",
          filterLists: "[data-category]",
          filterLinks: "[data-filter]",
          filterSelects: "select",
          filterCheckboxes: ":checkbox",
          activeClass: "active",
          loadingClass: "loading",
          filteringClass: "filtering",
          btnMore: ".btn-more",
          btnReset: ".btn-reset",
          ajaxPrefix: "ajax=1",
          paging: ".nav-links",
          usePaging: false,
          infiniteScroll: false,
          animSpeed: 500,
          delay: 500
      }, options);

      this.init();
  }

  AjaxFiltering.prototype = {
      init: function() {
          if (this.options.holder) {
              this.findElements();
              this.attachEvents();
              this.makeCallback("onInit", this);
          }
      },
      findElements: function() {
          this.win = $(window);
          this.holder = $(this.options.holder);
          this.container = this.holder.find(this.options.container);
          this.filterLists = this.holder.find(this.options.filterLists);
          this.searchForm = this.holder.find(this.options.searchForm);
          this.filterForm = this.holder.find(this.options.filterForm);
          this.filterCheckboxes = this.filterForm.find(this.options.filterCheckboxes);
          this.filterSelects = this.filterForm.find(this.options.filterSelects);
          this.btnReset = this.holder.find(this.options.btnReset);
          this.btnMore = this.holder.find(this.options.btnMore);
          this.paging = this.holder.find(this.options.paging);
          this.searchField = this.filterForm.find('[type="search"]');
          this.ajaxBusy = false;
          this.activeFilters = "";
      },
      attachEvents: function() {
          this.btnMore.on("click", (e) => {
              e.preventDefault();
              if (!this.ajaxBusy) {
                  this.ajaxRequest(this.btnMore.attr("href"));
              }
          });

          this.sendRequest = () => {
              if (!this.ajaxBusy) {
                  this.ajaxRequest(null);
              }
          };

          this.onScrollHandler = () => {
              this.scrollHandler();
          };

          this.attachLinksEvents();

          if (this.options.infiniteScroll) {
              this.win.on("scroll", this.onScrollHandler);
          }
      },
      attachLinksEvents: function() {
          this.filterLists.each((index, element) => {
              const list = $(element);
              const links = list.find(this.options.filterLinks);
              const parent = links.parent();

              links.on("click", (e) => {
                  e.preventDefault();
                  if (this.ajaxBusy) return;

                  const target = $(e.target);
                  const parentItem = target.parent();

                  if (list.data("multiselect")) {
                      let isActive = false;
                      if (parentItem.hasClass(this.options.activeClass)) {
                          parentItem.removeClass(this.options.activeClass);
                      } else {
                          parentItem.addClass(this.options.activeClass);
                          isActive = true;
                      }

                      if (target.data("filter").trim().toLowerCase() === "all") {
                          const items = list.children();
                          isActive ? items.addClass(this.options.activeClass) : items.removeClass(this.options.activeClass);
                      } else {
                          links.each((i, link) => {
                              const linkParent = $(link).parent();
                              if (linkParent.hasClass(this.options.activeClass) && $(link).data("filter").trim().toLowerCase() === "all") {
                                  linkParent.removeClass(this.options.activeClass);
                              }
                          });
                      }
                  } else {
                      if (parentItem.hasClass(this.options.activeClass)) {
                          parentItem.removeClass(this.options.activeClass);
                      } else {
                          parent.removeClass(this.options.activeClass);
                          parentItem.addClass(this.options.activeClass);
                      }
                  }

                  this.updateFilters();
                  this.sendRequest();
              });
          });

          this.filterForm.on("submit", (e) => {
              e.preventDefault();
              this.sendRequest();
          });

          this.searchForm.on("submit", (e) => {
              e.preventDefault();
              this.sendRequest();
          });

          this.searchField.on("search", () => {
              this.sendRequest();
          });

          this.filterCheckboxes.add(this.filterSelects).on("change", this.sendRequest);

          this.paging.on("click", "a", (e) => {
              e.preventDefault();
              const target = $(e.target);
              if (!this.ajaxBusy) {
                  this.ajaxRequest(null, target.data("page") || "1");
              }
          });

          this.btnReset.on("click", () => {
              if (this.filterForm.length) {
                  this.filterForm[0].reset();
              }
              if (this.searchForm.length) {
                  this.searchForm[0].reset();
              }
              this.filterSelects.each((index, element) => {
                  const options = $(element).find("option");
                  options.removeAttr("selected");
                  options.eq(0).attr("selected", true);
              });
              setTimeout(() => {
                  this.sendRequest();
              }, 500);
          });
      },
      scrollHandler: function() {
          if (
              this.win.scrollTop() + this.win.height() / 5 * 4 >=
                  this.container.offset().top + this.container.outerHeight() &&
              !this.ajaxBusy &&
              this.btnMore.length
          ) {
              this.ajaxRequest(this.btnMore.attr("href"));
          }
      },
      updateFilters: function() {
          this.activeFilters = "";
          this.filterLists.each((index, element) => {
              const list = $(element);
              const activeLinks = list.find(`.${this.options.activeClass} > ${this.options.filterLinks}`);
              let filters = [];
              activeLinks.each((i, link) => {
                  filters.push($(link).data("filter").trim());
              });
              if (filters.length) {
                  filters.forEach((filter) => {
                      this.activeFilters += `&${list.data("category")}=${filter}`;
                  });
              }
          });
      },
      ajaxRequest: function(url, page) {
          const formData = this.filterForm.length ? `&${this.filterForm.serialize()}` : "";
          const searchData = this.searchForm.length ? `&${this.searchForm.serialize()}` : "";
          let pagingData = "";

          if (this.options.usePaging) {
              pagingData = page ? `&page_num=${page}` : "&page_num=1";
          }

          this.ajaxBusy = true;
          this.btnMore.hide();
          this.holder.addClass(this.options.loadingClass);
          this.makeCallback("sendRequest", this);

          if (!url) {
              this.holder.addClass(this.options.filteringClass);
          }

          $.ajax({
              url: url || this.filterForm.attr("action"),
              type: this.filterForm.attr("method") || "POST",
              data: `${this.options.ajaxPrefix}${this.activeFilters}${formData}${searchData}${pagingData}`,
              dataType: "text",
              success: (response) => {
                  const isPaging = !!page;
                  this.onSuccess(response, url, isPaging);
              }
          });
      },
      onSuccess: function(response, url, isPaging) {
          const tempContainer = $("<div/>").html(response);
          const newItems = tempContainer.find(this.options.items);
          const newBtnMore = tempContainer.find(this.options.btnMore);
          const newPaging = tempContainer.find(this.options.paging);

          this.makeCallback("onLoad", newItems);

          setTimeout(() => {
              if (!url) {
                  this.container.empty();
                  this.makeCallback("onFilter", this, tempContainer);
              }

              this.holder.removeClass(this.options.filteringClass);
              newItems.hide().appendTo(this.container);

              if (newBtnMore.length) {
                  this.btnMore.attr("href", newBtnMore.attr("href"));
                  if (this.options.infiniteScroll) {
                      this.win.on("scroll", this.onScrollHandler);
                  } else {
                      this.btnMore.show();
                  }
              } else if (this.options.infiniteScroll) {
                  this.win.off("scroll", this.onScrollHandler);
              }

              if (newPaging.length) {
                  this.paging.html(newPaging.html());
              } else {
                  this.paging.html("");
              }

              this.makeCallback("onSuccess", newItems);
              this.holder.removeClass(this.options.loadingClass);
              newItems.fadeIn(this.options.animSpeed);

              if (isPaging) {
                  $("html, body").animate({ scrollTop: this.holder.offset().top }, 650);
              }

              this.ajaxBusy = false;
          }, this.options.delay);
      },
      makeCallback: function(name) {
          if (typeof this.options[name] === "function") {
              const args = Array.prototype.slice.call(arguments, 1);
              this.options[name].apply(this, args);
          }
      }
  };

  $.fn.ajaxFiltering = function(options) {
      return this.each((index, element) => {
          $(element).data("AjaxFiltering", new AjaxFiltering($.extend(options, { holder: element })));
      });
  };
})(jQuery);

function searchBlog() {
  const htmlBody = jQuery("html, body");
  const mainElements = jQuery("body").find("#main");

  mainElements.each(function () {
      const mainElement = jQuery(this);
      const searchForm = mainElement.find(".product-search-form");
      
      if (mainElement.find(".filter-section").length) {
          return;
      }

      const searchInput = mainElement.find('.form-group input[type="search"]');
      const filterHolder = mainElement.find(".filter-holder");
      const tagSelector = ".tags";
      const tagsContainer = searchForm.find(tagSelector);
      const tagLinks = tagsContainer.find("a");
      const activeClass = "active";
      const requestUrl = document.location.href + "/?ajax=1";

      let requestData = {
          search: "",
          cat: "",
          pagen: ""
      };

      function updateContent() {
          Object.keys(requestData).reduce((query, key) => 
              requestData[key] === undefined || requestData[key] === "" 
                  ? query 
                  : `${query}&${key}=${requestData[key]}`
          , requestUrl);
          
          mainElement.css({ height: mainElement.height() })
              .stop()
              .animate({ opacity: 0 }, {
                  duration: 300,
                  complete: function () {
                      jQuery.ajax({
                          url: requestUrl,
                          type: "get",
                          data: requestData,
                          success: function (response) {
                              const content = jQuery("<div></div>").html(response);
                              filterHolder.empty().append(content.html());
                              mainElement.stop().animate({ opacity: 1 }, { duration: 300 });
                              mainElement.css({ height: "" });
                          },
                          error: function (error) {
                              console.error("AJAX Error:", error);
                          }
                      });
                  }
              });
      }

      function updateFilters() {
          requestData.search = searchInput.val();
          requestData.cat = tagLinks.filter(`.${activeClass}`).data("name") || "";
          requestData.pagen = 1;
      }

      tagsContainer.on("click", "a", function (event) {
          event.preventDefault();
          const clickedTag = jQuery(event.target);
          
          tagLinks.removeClass(activeClass);
          clickedTag.addClass(activeClass);
          
          updateFilters();
          requestData.cat = clickedTag.data("name");
          updateContent();

          htmlBody.stop().animate({ scrollTop: mainElement.offset().top });
      });

      filterHolder.on("click", ".page-numbers", function (event) {
          event.preventDefault();
          updateFilters();
          requestData.pagen = jQuery(this).data("pagen");
          updateContent();

          htmlBody.stop().animate({ scrollTop: mainElement.offset().top });
      });

      if (searchInput.length) {
          searchInput.on("keydown", function (event) {
              if (event.which === 13 || event.keyCode === 13) {
                  event.preventDefault();
                  updateFilters();
                  requestData.search = event.target.value;
                  updateContent();
                  
                  htmlBody.stop().animate({ scrollTop: mainElement.offset().top });
                  return false;
              }
          });

          searchInput.on("search", function () {
              requestData.search = "";
              updateFilters();
              updateContent();

              htmlBody.stop().animate({ scrollTop: mainElement.offset().top });
          });
      }
  });
}
